import { inject, Injectable } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { StoreService } from '../store/store.service';
import { getAuth, getMultiFactorResolver, multiFactor, TotpMultiFactorGenerator } from 'firebase/auth';
import { CookiesService } from '../cookies/cookies.service';
import { NS_Enums } from 'src/app/static/namespace';
import { Router } from '@angular/router';
import {
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
} from '@angular/material/dialog';
import { catchError, of, switchMap } from 'rxjs';
import { ExpireMfaComponent } from 'src/app/shared/components/expire-mfa/expire-mfa.component';
import { RequestParam } from 'src/app/interfaces/requestParam';
import { API_CONSTANTS } from 'src/app/static/api.constant';
import { DataService } from '../data/data.service';
import { ActivatedRoute } from '@angular/router';
import { normalizeEmail } from 'src/app/shared/email.helper';

@Injectable({
  providedIn: 'root'
})
export class MfaService {

  private authService: AuthService = inject(AuthService);
  private store: StoreService = inject(StoreService);
  private cookieService: CookiesService = inject(CookiesService);
  private router: Router = inject(Router);
  private dataService = inject(DataService);
  private activatedRoute = inject(ActivatedRoute);

  readonly dialog = inject(MatDialog);
  expireMfaDialog: MatDialogRef<any>;

  totpSecret: any;
  qrCode: any;
  mfaResolver: any;
  constructor() { }

  mfaConfig(){
    return new Promise((s, r)=>{
      this.authService.mfaConfig()
        .then((totpSecret)=>{
          if(totpSecret){
            this.totpSecret = totpSecret;
            const totpUri = this.totpSecret.generateQrCodeUrl(
              this.store.getUser().email,
              "Saras Analytics"
            );
            this.qrCode = totpUri;
            s({qr: this.qrCode, totpSecret: this.totpSecret});
            return;
          }
          console.log(this.qrCode);
          r('current-user-empty');
          return;
        })
        .catch((e)=>{
          console.log(e);
          r(e);
        })
    })
  }

  verifyConfigurationCode(verificationCode: string){
    return new Promise((s, r)=>{
      console.log('Verify Code', verificationCode);
      const multiFactorAssertion = TotpMultiFactorGenerator.assertionForEnrollment(
        this.totpSecret,
        verificationCode)
      this.authService.afAuth.currentUser.then((currentUser: any)=>{
        if(currentUser){
          multiFactor(currentUser).enroll(multiFactorAssertion, currentUser.displayName).then((res)=>{
            s(res);
          }).catch((e)=>{
            console.log(e);
            r(e.code || 'error');
          })
        }
      })
    })
    
  }

  mfaLogin(error: any){
    this.mfaResolver = getMultiFactorResolver(this.authService.auth, error);
    const enrolledFactors = this.mfaResolver.hints.map((info: any) => info.displayName);
    this.router.navigate(['verify-mfa'], { queryParams: { ...this.activatedRoute.snapshot.queryParams } });
  }

  verifyMfaCode(otp: any){
    return new Promise((s, r)=>{
      const multiFactorAssertion = TotpMultiFactorGenerator.assertionForSignIn(
        this.mfaResolver.hints[0].uid,
        otp
      );
      try {
        this.mfaResolver.resolveSignIn(multiFactorAssertion).then((res: any)=>{
          console.log('resolveSignIn', res);
          s(res);
        }).catch((e: any)=>{
          console.log(e);
          r(e);
        })
      } catch (error) {
        r(error);
        // Invalid or expired OTP.
      }
    })
  }

  getUserDetailsFromEmail(email: string){
    const normalizedEmail = normalizeEmail(email);
    const headers = new Map();
    headers.set('skip', 'true');
    const requestParam: RequestParam = {
      url: API_CONSTANTS.USER_FROM_EMAIL,
      params: {email: normalizedEmail},
      headers: Object.fromEntries(headers)
    };
    return this.dataService.get(requestParam).pipe(
      switchMap((response: any) => {
        if(response && response.data){
          return of({success: true, data: response.data});
        }
        return of({success: false, err: response});
      }),
      catchError((err: any) => {
        return of({success: false, err});
      })
    )
  }

  showDialog(){
    this.expireMfaDialog = this.dialog.open(ExpireMfaComponent,{
      width:'771px',
      height:'531px',
      hasBackdrop:true,
      disableClose: true
    })
    this.expireMfaDialog.afterClosed().subscribe(this.cancleSetup.bind(this));
  }

  cancleSetup(){
    this.expireMfaDialog && this.expireMfaDialog.close();
    this.router.navigate(['/products']); 
  }

}
